export default "__VITE_ASSET__hk$k9nB0__"